import { createAction } from "redux-actions";

// ResetLoader
export const RESET_LOADER = 'RESET_LOADER';
export const ResetLoader = createAction(RESET_LOADER);

// ShowLoader
export const SHOW_LOADER = 'SHOW_LOADER';
export const ShowLoader = createAction(SHOW_LOADER);

// HideLoader
export const HIDE_LOADER = 'HIDE_LOADER';
export const HideLoader = createAction(HIDE_LOADER);
